import axios from 'axios';
import store from '@/store';
import router from '@/router/router';
import { Loading, Message } from 'element-ui';
import { Base64 } from 'js-base64';
import _ from 'lodash';

import settings from '@/config/vd-settings';
import vdui from '@/util/vdui';
import { getToken } from '@/util/auth';

const service = axios.create({
  timeout: settings.timeout, // 请求超时时间
  headers: { api_version: 'v1' },
  withCredentials: true,
});

let whLoading = {};

function throwErrorMsg(msg) {
  Message.error(msg);
}

//HTTPrequest拦截
service.interceptors.request.use(
  (config) => {
    if (!(config.withHeaders === false)) {
      config.headers['Authorization'] = `Basic ${Base64.encode(
        `${settings.clientId}:${settings.clientSecret}`
      )}`;
      if (getToken()) {
        // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
        config.headers['Blade-Auth'] = 'bearer ' + getToken();
      }
    }
    //自定义头
    if (vdui.isNotEmpty(config.vHeaders)) {
      _.merge(config.headers, config.vHeaders);
    }
    //加载圈
    if (vdui.isNotEmpty(config.showLoading)) {
      whLoading = Loading.service(
        _.merge({ lock: true, text: 'Loading', spinner: 'el-icon-loading' }, config.showLoading)
      );
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
//HTTPresponse拦截
service.interceptors.response.use(
  (response) => {
    if (whLoading.visible) {
      whLoading.close();
    }
    //格式化处理返回值
    if (response.config.parseResp === false) {
      return response;
    }
    const res = response.data;
    if (res[settings.codeName] === settings.codeSuccess) {
      return res;
    } else if (res[settings.codeName] === settings.codeTokenError) {
      store.dispatch('FedLogOut').then(() => router.push({ path: '/login' }));
    } else {
      throwErrorMsg(res[settings.descName]);
      return Promise.reject(res);
    }
  },
  (error) => {
    console.log('error==>', error);
    if (error.response) {
      const contentType = error.response.headers['content-type'];
      if (contentType && contentType.indexOf('application/json') > -1) {
        throwErrorMsg(error.response.data[settings.descName]);
      } else {
        throwErrorMsg(error.response.statusText);
      }
    } else {
      throwErrorMsg(`${error}`);
    }

    window.app.__vue__.$nextTick(() => {
      if (whLoading.visible) {
        whLoading.close();
      }
    });
    return Promise.reject(error);
  }
);


export default service;
